import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import Card from '../../Fuse/Card';
import FuseInfoTooltip from '../../FuseControls/FuseTooltip/FuseInfoTooltip';
import FuseReadOnlyRadioButton from '../../FuseControls/FuseReadOnlyRadioButton';
import FileRuleActionStore from '../../../stores/Policy/FileRules/FileRuleActionStore';
import FuseConsoleCardFooter from '../../ConsoleFragments/FuseConsoleCardFooter';
import { RULE_REC_TYPE } from '../../../constants';

const PREVIEW_HELP_TEXT_1 = 'Supported File Preview Extensions: doc, dot, docx, dotx, xls, xlsb, xlt, ' +
    'xla, xlsx, ppt, pot, pps, ppa, pptx, ppsx, pdf, odt, odp, ods';
const FOOTER_TAP_TEXT = 'Your current Isolation license does not support uploads or downloads.';

class FileRuleAction extends Component {
    static propTypes = {
        store: FileRuleActionStore.PropType.isRequired,
        readOnly: PropTypes.bool,
        showPreviewAction: PropTypes.bool,
        ruleType: PropTypes.string,
        isTapLicense: PropTypes.bool,
    };

    componentDidMount = () => {
        const { store } = this.props;

        store.setAllowUploadDownload(!this.props.isTapLicense);
    }

    render() {
        const { store, readOnly, showPreviewAction, ruleType, isTapLicense } = this.props;
        const scanLabel = ruleType === RULE_REC_TYPE.FILE_THREAT_RULES ? 'Threat Scan conditions (Malware Detection)'
            : 'DLP Scan conditions (Detector Sets)';

        return <Card title="Action">
            <FuseReadOnlyRadioButton
                value={'BLOCK'}
                readOnly={readOnly}
                store={store.action}
                label={'Block'}
                qa={'block-radio'}
            />
            {showPreviewAction ? <FuseReadOnlyRadioButton
                value={'PREVIEW'}
                readOnly={readOnly}
                store={store.action}
                label={<div style={{ display: 'flex' }}>
                    Block and provide supported previews (Downloads Only)
                    <FuseInfoTooltip>
                        <Fragment>{PREVIEW_HELP_TEXT_1}</Fragment>
                    </FuseInfoTooltip>
                </div>}
                qa={'preview-radio'}
            /> : null}
            {(store.originalValue.action === 'ALLOW' || !isTapLicense) ? <FuseReadOnlyRadioButton
                value={'ALLOW'}
                readOnly={readOnly}
                disabled={isTapLicense}
                store={store.action}
                label={'Allow'}
                qa={'allow-radio'}
            /> : null}
            {(store.originalValue.action === 'SCAN' || !isTapLicense) ? <FuseReadOnlyRadioButton
                value={'SCAN'}
                readOnly={readOnly}
                disabled={isTapLicense}
                store={store.action}
                label={`Define action based on ${scanLabel}`}
                qa={'scan-radio'}
            /> : null}
            {isTapLicense ? <FuseConsoleCardFooter
                wrapperStyle={{ marginTop: '20px' }}
                text={FOOTER_TAP_TEXT}
            /> : null }
        </Card>;
    }
}

export default observer(FileRuleAction);
